/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Product page
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    // Add to cart - Ajax
    $cartCount: $('.cart-count'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit'),

    //Navigation
    $hasDropdownItem: $('.site-nav--has-dropdown')
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

theme.init = function () {
  theme.cacheSelectors();
  theme.mobileNav();
  timber.cacheVariables();
  theme.equalHeights();
  theme.cartPage();
  theme.toggleMenu();

  
    theme.productImageGallery();
  

  
    theme.enableAjax();
  
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

theme.equalHeights = function () {
  theme.cache.$w.on('load', resizeElements());

  theme.cache.$w.on('resize',
    afterResize(function() {
      resizeElements();
    }, 250, 'equal-heights')
  );

  function resizeElements() {
    theme.cache.$productGridImages.css('height', 'auto').equalHeights();
    theme.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }
};

theme.productImageGallery = function() {

  if (!theme.cache.$productImageGallery.length) {
    return;
  };

  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: LS.localization.variable( 'products.zoom.close', 'Cerrar (esc)', '', '' ),
    removalDelay: 500,
    callbacks: {
      open: function(){
        $('html').css('overflow-y','hidden');
      },
      close: function(){
        $('html').css('overflow-y','');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: LS.localization.variable( 'products.zoom.prev', 'Anterior (tecla de flecha izquierda)', '', '' ),
      tNext: LS.localization.variable( 'products.zoom.next', 'Siguiente (tecla de flecha derecha)', '', '' )
    }
  });

  theme.cache.$productImage.bind('click', function() {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });
};

theme.cartPage = function () {
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};

theme.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};

theme.addToCartflip = function ($addToCartBtn) {

  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || LS.localization.variable( 'products.product.add_to_cart', 'AÑADIR AL CARRITO', '', '' );

  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
    .clone(true)
    .prop('disabled', false)
    .removeClass('disabled')
    .addClass('btn--unflipped')
    .find('span')
    .text(addToCartText)
    .end()
    .hide()
    .insertAfter($addToCartBtn);

  $addToCartBtn
    .unbind('click')
    .removeClass('disabled')
    .find('span')
    .text(LS.localization.variable( 'products.product.view_cart', 'VER CARRITO', '', '' ))
    .end()
    .bind('click', function(e) {
      e.preventDefault();
      window.location.href = '/cart';
    })
    .prop('disabled', false)
    .addClass('btn--flipped')
    .after('<span class="continue-shopping"> <a class="btn--secondary" style="width:100%; " href="/collections/all">' + LS.localization.variable( 'products.product.continue_shopping', 'SEGUIR COMPRANDO', '', '' ) + '</a></span>');

  $('.continue-shopping a').bind('click', theme.backButton);

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

theme.enableAjax = function () {
  theme.cache.$addToCartBtn.bind('click', function(e) {
    e.preventDefault();
    $('.note.errors').remove();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');
    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        .prop('disabled', true)
        .addClass('disabled')
        .addClass('btn--loading');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
          $.getJSON('/cart.js', function(cart) {
            theme.cache.$cartCount.text(cart.item_count);
            $('.hidden-count').removeClass('hidden-count');
          });
          $addToCartBtn.removeClass('btn--loading');
          theme.addToCartflip($addToCartBtn);
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text(LS.localization.variable( 'products.product.sold_out', 'Próximamente', '', '' ));
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          $addToCartBtn.after('<p class="note errors">' + response + '</p>');
        }
      });
    }
  });
};

theme.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';

  // Open sub navs on small screens
  theme.cache.$hasDropdownItem.on('click', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      $doc.on('click', handleClickOutsideDropdown);
    }

    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);

      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        $doc.off('click', handleClickOutsideDropdown)
      }
    }
  })
};

// Initialize theme's JS on docready
$(theme.init)


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// START CODE vShop //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


$(document).ready(function(){
  
	/// SHOPIFY HELPERS
	
  	var Shopify = Shopify || {};
  	var queueLength;
	var thisUUID;
	var iNum = 0;
    // ---------------------------------------------------------------------------
    // Money format handler
    // ---------------------------------------------------------------------------
	Shopify.money_format = "$";
  
	Shopify.formatMoney = function(cents, format) {
      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || this.money_format);

      function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
      }

      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
	};
	Shopify.moveAlongOneTime = function() {
		if (Shopify.queue.length) {
        	var request = Shopify.queue.shift();
          	//console.log("request:",request);
        	Shopify.addItemOneTime(	 request.variantId
                                   , request.quantity
                                   , request.thisUUID
                                   , request.addon
                                   , Shopify.moveAlongOneTime
                                   , Shopify.queue.length
                                   , request.send_subscription_id
                                   , request.send_interval_unit);
      	} else {
        	setTimeout(function() {
				document.location.href = '/cart';
        	}, 500);
      }
    };
	
	Shopify.addItemOneTime = function(lineVariant, lineTotal, thisUUID, addon, callback, queueLength,queueSubscription,queueIntervalUnit) {
		var data = {
			"id" : lineVariant,
			"quantity" : lineTotal,
            "properties[subscription_id]": queueSubscription,
            "properties[shipping_interval_unit_type]": queueIntervalUnit,
            "properties[shipping_interval_frequency]": 1
              
		//	"properties[_type]" : 'control',
		//	"properties[_key]" : guid(),
		//	"properties[_masterHandle]" : 'paleobull-box',
		//	"properties[_length]" : queueLength
		}
			
		//console.log(data);
      	
		// if addon string is not empty, it is an addon (duh!)
		if (addon != "") {
			data["properties[_addon]"] = addon;
		}
        
		$.ajax({
        	type: 'POST',
        	url: '/cart/add.js',
        	dataType: 'json',
        	data: data,
        	success: function(){
        		if(typeof callback === 'function'){
          			callback();
        		}
        	},
        	error: function (request, status, error) {
        		console.log(request.responseText);
        	}
      		});
	}


		
  // tratamiento de añadir productos
	
  $('.product__purchase--method').on('click', function() {
    $('.product__purchase--method').removeClass('active');
    $(this).addClass('active');

    if($(this).data('method') == 'single'){
      $('.product__purchase--subscription--options').removeClass('active');
      $('.subscription-frequency').removeClass('active');
      $('#addToCart').show();
      $('#addToCartSub').hide();
      // show the limited edition flavours 
      $.each(limitedFlavours, function(index, element) {
        $(this).removeClass('hidden');
      });
    } else {                
      $('.product__purchase--subscription--options').addClass('active');
      $('.subscription-frequency').addClass('active');
      $('#addToCart').hide();
      $('#addToCartSub').show();
      // hide the limited edition flavours 
      $.each(limitedFlavours, function(index, element) {
        $(this).addClass('hidden');
        $(this).find(".product__flavour--option--number").val(0);
      });
    }

    updateTotalBags(); // now includes price
  });
		
  $('.product__purchase--method').on('click', function(){
    $('.product__purchase--method').removeClass('active');
    $(this).addClass('active');
  });

  $('.product__flavour--option--control').on('click', function(e){
    e.preventDefault();

    var minVal = 0,
        maxVal = 99,
        input = $(this).siblings('.product__flavour--option--number'),
        dataType = $(this).attr('data-type'),
        currentVal = parseInt(input.val()),
        totalVal = 0,
        newVal = 0;


    $('.product__flavour--option').each(function(){
      var newVal = parseFloat($(this).find('.product__flavour--option--number').val());

      if(newVal){
        totalVal = parseFloat(totalVal + newVal);
      }
    });

    if(totalVal < maxVal){

      if(dataType == 'plus') {
        if(currentVal < maxVal){
          input.val(currentVal + 1).change();
        }
      }

    }

    if(dataType == 'minus') {
      if(currentVal > minVal){
        input.val(currentVal - 1).change();
      }
    }

    updateTotalBags();

  });
		
  function updateTotalBags(){

    var newNum = 0,
        thisNum = 0,
        mealsPerPouch = 1,
        caloriesPerMeal = 300,
        totalMeals,
        totalCalories,
        itemWeight = 100;
    totalPrice=0.00;

    $('.product__flavour--option--number').each(function(){
    	thisNum = parseInt($(this).val()),
    	newNum = parseInt(thisNum + newNum);
    });
   
    $('.total__bags').html(newNum).css("display", "none");;
    
    totalMeals = parseInt(mealsPerPouch * newNum);
    totalCalories = parseInt(totalMeals * caloriesPerMeal);
    $('.product__purchase--totalmeals').html('<isolate><var>' + totalMeals + '</var>  / <var>' + totalCalories + '</var> calories' + '</isolate>');

    var bagTotal = 0, 
        newVal,
        bagPrice,
        totalPrice = 0,
        dataList = $('.product__purchase--totalmeals, .product__purchase--costpermeal, .product__purchase--wasprice, .product__purchase--price, .product__purchase--costperhundred'),
        singlePouchPrice = '',
        price,
        totalWeight;

    $('.product__flavour--option').each(function(){
      var newVal = parseFloat($(this).find('.product__flavour--option--number').val());
      $(this).attr('data-total', newVal);
      if(newVal){bagTotal = parseFloat(bagTotal + newVal);}
      if(bagTotal){totalWeight = bagTotal * itemWeight};
    });			

    if (bagTotal >= 1){

    	$('.product__flavour--option').each(function(){
        	totalData= parseFloat($(this).find('.product__flavour--option--number').val());
        	//console.log('totalData : ' + totalData); 
        	//console.log('totalPrice : ' + totalPrice);
        	//console.log('Id : ' + $(this).data('id')); 
        	if (totalData>0) {

          		bagPrice = parseFloat(parseFloat($(this).data('price')*totalData));
        		totalPrice = parseFloat(totalPrice + bagPrice)
        	}

        	//$(this).attr('data-onetime-id', childProducts[0][thisArray]["Default Title"].variantID);
		});

      	//console.log('bagPrice : ' + bagPrice); 
      	//console.log('bagTotal : ' + bagTotal); 
      	//console.log('totalPrice : ' + totalPrice); 
		//totalPrice = parseFloat(bagPrice * bagTotal).toFixed(2);

		var priceNoDiscount = parseFloat(singlePouchPrice * bagTotal).toFixed(2);

		$('.product__purchase--wasprice').show().html(Shopify.formatMoney(priceNoDiscount, " €"));


		$('.product__purchase--price').html(Shopify.formatMoney(totalPrice, " €"));
		if(bagTotal < 2){
        	$('.product__purchase--wasprice').hide();
      	} else {
        	$('.product__purchase--wasprice').show();
      	}

      	$('.product__purchase--wasprice').hide();
      	price = totalPrice;
    }

    if(bagTotal < 1){
    	dataList.addClass('no-data');
    	$('.product__purchase--price').html("0.00 €");
    } else {
    	dataList.removeClass('no-data');
    }

    var visualCost = $('.product__purchase--costpermeal'),
    newCPM = parseFloat( price / ( mealsPerPouch * bagTotal ) ).toFixed(2);

    if(bagTotal > 0){
      visualCost.html('<isolate>' + Shopify.formatMoney(newCPM, 'Only <var>' + " €") + '</var> ' + '</isolate>');
    }

  }
		
  $('.product__flavour--option--control').on('click', function (e) {
  	totalSelected();
  }); 

  function totalSelected(){
    var totalSelected = 0,
        newVal = 0;
    $('.product__flavour--option').each(function(){
      var newVal = parseFloat($(this).find('.product__flavour--option--number').val());
      if(newVal){totalSelected = parseFloat(totalSelected + newVal);}
    });
    if(totalSelected > 0){
      $('#addToCartAll').prop('disabled', false).val('Suscripción');
      // switchVariant(totalSelected);
    } else {
      $('#addToCartAll').prop('disabled', true).val('');
    }
    
  }


  $('label[for^=addon-]').on('click', function(){
    $(this).toggleClass('active');
    $(this).next('span').toggleClass('active');
    var addOnPrice = $(this).next('span').data('price');
    $('.product__purchase--addon--price').html('+ ' + addOnPrice);
    $('.product__purchase--addon--price').toggleClass('active');
  });
		
  totalSelected();

  updateTotalBags();

  
		

	// ***********************************		 
	// añadir a carrito
	// ***********************************
	
	function addToQueue (lineVariant, lineTotal, thisUUID, addon,send_subscription_id,send_interval_unit) {
		Shopify.queue.push({
			"variantId": lineVariant,
			"quantity": lineTotal,
			"thisUUID": thisUUID,
        	"addon": addon,
          	"send_subscription_id": send_subscription_id,
          	"send_interval_unit": send_interval_unit
		});
	}
  	function guid() {
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000)
		  		.toString(16)
		  		.substring(1);
	  	}
	  	return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}
  
  	var addToCartAllButton = document.getElementById("addToCartAll");
  	var send_subscription_id = $('#rc_subscription_id').val();
  	var send_interval_unit = $('#rc_shipping_interval_unit_type').val();
  	//console.log(send_subscription_id);
    if (  addToCartAllButton ) {

        addToCartAllButton.addEventListener('click', function(){
            document.querySelector(".product_purchase__add-to-cart-buttons").classList.add("loading");
            addToCartAllButton.setAttribute("disabled", true);
            addToCartAllButton.value = "";
            document.body.style.cursor = "progress";

            var totalBags = parseInt(document.querySelector('.total__bags').textContent);

            Shopify.queue = [];
            thisUUID = guid();

            //console.log("Shopify Queue:", Shopify.queue);
            //console.log("thisUUID:"+ thisUUID);
            // añadimos todas las variantes
            $('.product__flavour--option').each(function(){
                var lineTotal = parseFloat($(this).find('.product__flavour--option--number').val()),
                    lineVariant = $(this).data('id')
                	;
                if (lineTotal > 0) {
                    addToQueue (lineVariant, lineTotal, thisUUID, "", send_subscription_id,send_interval_unit ); //empty string to specify this isn't an addon
                }
            });


            queueLength = Shopify.queue.length;
            //console.log("Shopify Queue:", Shopify.queue);
            Shopify.moveAlongOneTime();

        });
    }
  
  
});
// END CODE vShop.es
  

// INI PHM

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].onclick = function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
}
  
// FIN PHM